// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__i7Yu5","subheader":"ReorderModal_subheader__gBFUQ","listWrap":"ReorderModal_listWrap__3m7hv"};